// Shared by the animated pixel components: they all stop moving for
// prefers-reduced-motion and do their heavy rendering while the browser is idle.

const query = window.matchMedia('(prefers-reduced-motion: reduce)')

export function reducedMotion () {
    return query.matches
}

// Calls `fn` whenever the preference changes; returns the unsubscribe function.
export function watchReducedMotion (fn) {
    query.addEventListener('change', fn)
    return () => query.removeEventListener('change', fn)
}

export function whenIdle (fn, timeout = 500) {
    if ('requestIdleCallback' in window) return window.requestIdleCallback(fn, { timeout })
    return setTimeout(fn, 30)
}

// Calls `fn(visible)` when the element scrolls in or out of view or the tab
// is hidden or shown; returns the unsubscribe function.
export function watchOnScreen (el, fn) {
    let intersecting = false
    const update = () => fn(intersecting && !document.hidden)
    const observer = new IntersectionObserver(([entry]) => {
        intersecting = entry.isIntersecting
        update()
    })
    observer.observe(el)
    document.addEventListener('visibilitychange', update)
    return () => {
        observer.disconnect()
        document.removeEventListener('visibilitychange', update)
    }
}
